import Highcharts, { chart } from 'highcharts/highstock'
import { formatNumber } from '../utils/Number'
import { highchartsOptions } from './chart-options'

Highcharts.setOptions(highchartsOptions)

const attach = (element) => {
    const parser = element.dataset.chartParser || 'normal'

    const formatPoint = (point) => {
        return `<span style="color: ${point.color}">${point.series.name}: </span> <b>${formatNumber(
            point.y,
        )}</b>`
    }

    let chartOptions = {
        chart: {
            renderTo: element,
            alignTicks: false,
            spacingBottom: 50,
            type: 'line',
            animation: false,
            zooming: {
                mouseWheel: false,
            },
        },
        credits: {
            enabled: false,
        },
        rangeSelector: {
            enabled: false,
        },
        plotOptions: {
            series: {
                stacking: undefined,
            },
            line: {
                pointInterval: 24 * 3600 * 1000,
                lineWidth: 1.5,
            },
        },
        title: null,
        legend: {
            enabled: true,
            align: 'center',
            borderWidth: 0,
            layout: 'horizontal',
            y: 35,
        },
        navigator: {
            enabled: false,
        },
        scrollbar: {
            enabled: false,
        },
        tooltip: {
            formatter: function () {
                let s = []

                s.push(`<b>${Highcharts.dateFormat('%d. %m. %Y', this.x)}</b>`)

                if (parser === 'categories') {
                    s.push(`Celkem: <b>${formatNumber(this.points[0].total)}</b>`)
                }

                this.points.forEach((point) => s.push(formatPoint(point)))

                return s.join('<br>')
            },
        },
        series: [],
        xAxis: {
            minRange: 24 * 3600 * 1000,
        },
        yAxis: [
            {
                opposite: false,
                min: 0,
                labels: {
                    align: 'right',
                },
                title: {
                    text: 'Počet načtení stránky',
                },
            },
        ],
    }

    const data = JSON.parse(element.dataset.chartData)

    if (parser === 'normal') {
        const parsedData = Object.entries(data).map(([key, value]) => [
            parseInt(key) - 1 * 60 * 60 * 1000,
            value,
        ])
        const hasVisits = parsedData.some(([, value]) => 'visits' in value)
        const hasViews = parsedData.some(([, value]) => 'views' in value)

        chartOptions.series = [
            hasVisits
                ? {
                      yAxis: 0,
                      opposite: false,
                      name: 'Počet navštěv stránky',
                      data: parsedData.map(([key, value]) => [key, value.visits]),
                  }
                : null,
            hasViews
                ? {
                      yAxis: hasVisits ? 1 : 0,
                      opposite: true,
                      name: 'Počet zobrazení upoutávky',
                      data: parsedData.map(([key, value]) => [key, value.views]),
                  }
                : null,
        ].filter(Boolean)

        if (hasViews) {
            chartOptions.yAxis.push({
                opposite: true,
                min: 0,
                gridLineWidth: 0,
                labels: {
                    align: 'left',
                },
                title: {
                    text: 'Počet zobrazení upoutávky',
                },
            })
        }
    } else if (parser === 'categories') {
        chartOptions.series = Object.entries(data)
            .reduce((series, [key, item]) => {
                Object.entries(item).forEach(([categoryId, value]) => {
                    if (value.name === 'Vše') {
                        return series
                    }
                    const index = parseInt(categoryId)
                    if (!series[index]) {
                        series[index] = {
                            name: value.name,
                            data: [],
                        }
                    }
                    series[index].data.push([
                        parseInt(key) - 1 * 60 * 60 * 1000,
                        value.items_visits,
                    ])
                })

                return series
            }, [])
            .filter(Boolean)

        chartOptions.plotOptions.series.stacking = 'normal'
    }

    if (chartOptions.series.length < 2) {
        chartOptions.legend.enabled = false
        chartOptions.chart.spacingBottom = 20
    }

    new Highcharts.stockChart(chartOptions)
}

document.querySelectorAll('.chart-stats').forEach(attach)
